"use client";

/**
 * DiamondDivider.tsx
 *
 * A signature decorative element for the Royal Blue theme.
 * Consists of three rotated squares (diamonds) flanked by thin lines.
 */

import React from "react";
import { motion } from "framer-motion";

interface DiamondDividerProps {
  className?: string;
  light?: boolean; // If true, lines and diamonds are more subtle (white/opacity)
}

const DiamondDivider = ({
  className = "",
  light = false,
}: DiamondDividerProps) => {
  // Base colors for the "Classic" look vs the "Light/Overlay" look
  const lineColor = light ? "bg-[#c59d5f]/30" : "bg-[#c59d5f]/30";
  const diamondColor = light ? "border-[#c59d5f]" : "bg-[#c59d5f]";

  return (
    <div className={`flex justify-center items-center gap-4 ${className}`}>
      {/* Left line */}
      <div className={`w-12 h-[1px] ${lineColor}`} />

      {/* Center diamonds */}
      <div className="flex gap-1">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`w-1.5 h-1.5 rotate-45 ${
              light ? "border border-[#c59d5f]" : "bg-[#c59d5f]"
            }`}
          />
        ))}
      </div>

      {/* Right line */}
      <div className={`w-12 h-[1px] ${lineColor}`} />
    </div>
  );
};

export default DiamondDivider;
